var timeline_controller = {
    init: function(){
        if(jQuery('.timeline').length){
            jQuery('select.timeline-nav').on('change', function(){
                var val = jQuery(this).val();
                jQuery('ul.timeline-nav li a[href="'+val+'"]').trigger('click');
            });

            timeline_controller.animateTimeline();
        }
    },

    animateTimeline: function(){
        jQuery('.timeline').each(function(){
            var timeline = jQuery(this);
            var timelineLine = timeline.find('.container > .timeline > figure.line');
            var timelineCards = timeline.find('.timeline-card');

            // So first we should animate the line in, then when thats done, we should animate the cards in one by one when they come into the viewport. We can use the scroll event to check when they come into the viewport and then animate them in.
            timelineLine.addClass('animate');

            jQuery('body').addClass('timeline-animate');

            // onload
            timelineCards.each(function(index){
                var card = jQuery(this);
                if(card.hasClass('animate')) return; // If the card has already been animated, skip it.
                var cardTop = card.offset().top;
                var cardHeight = card.height();
                var windowScrollTop = jQuery(window).scrollTop();
                var windowHeight = jQuery(window).height();

                card.find('figure.line').css('animation-delay', (index * 200) + 'ms');
                card.css('animation-delay', (index * 500) + 'ms');
                card.addClass('animate');
            });
        });
    }
};

jQuery(document).ready(function(){
    timeline_controller.init();
});